import { render, staticRenderFns } from "./intial-config.vue?vue&type=template&id=0bc3c42a&scoped=true&"
var script = {}
import style0 from "./intial-config.vue?vue&type=style&index=0&id=0bc3c42a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc3c42a",
  null
  
)

export default component.exports